<template>
    <div>
        <loading v-show="loading"></loading>

        <user-edit v-if="!loading" :user="user" @reload="load"></user-edit>
    </div>
</template>

<script>
import Loading from "../components/UI/Loading.vue";
import UserEdit from "../components/UserEdit.vue";

export default {
    name: "UserEditPage",

    components: {UserEdit, Loading},

    props: ['id'],

    data: () => ({
        user: null,
        loading: true,
    }),

    mounted() {
        this.load();
    },

    methods: {
        load() {
            this.loading = true;
            this.$http.get('/admin/users/' + this.id).then((response) => {
                this.user = response.data.data;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            });
        }
    }
}
</script>

<style scoped>

</style>
